import Repository from './repository'

export default {
  plans() {
    return Repository.get('/subscription/plans')
  },
  me() {
    return Repository.get('/subscription/me')
  },
  checkout(slug) {
    return Repository.post(`/subscription/checkout/${slug}`)
  },
  cancel(reason) {
    return Repository.post('/subscription/cancel', { reason })
  },
  syncStatus() {
    return Repository.post('/subscription/sync-status')
  },
  publicCheckout(payload) {
    return Repository.post('/subscription/public-checkout', payload)
  },
}
